import { COMMON_API_ENDPOINTS } from "./apiEndPoints";
import { baseApi } from "@/utils/baseApi";

export const commonApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchCommonApi: builder.query({
      query: ({ endpoint, params = {} }) => {
        const url = COMMON_API_ENDPOINTS[endpoint]?.(params);
        if (!url) throw new Error(`Invalid endpoint: ${endpoint}`);
        return { url, method: "GET" };
      },
      transformResponse: (response) => response?.data ?? [],
      providesTags: [{ type: "FetchCommonApi", id: "LIST" }],
    }),

    // department, desigination, gender and band 
    commonApi: builder.query({
      query: (referenceName) => ({
        url: COMMON_API_ENDPOINTS.COMMON_API(referenceName),
        method: "GET",
      }),
      transformResponse: (response) => response?.data ?? [],
      providesTags: [{ type: "CommonAPI", id: "LIST" }],
    }),
    commonSettingsApi: builder.query({
      query: (name) => ({
        url: COMMON_API_ENDPOINTS.SETTINGS(name),
        method: "GET",
      }),
      transformResponse: (response) => response?.data ?? [],
      providesTags: [{ type: "CommonSettings", id: "LIST" }],
    }),
  }),
});

export const { useFetchCommonApiQuery, useCommonApiQuery, useCommonSettingsApiQuery } = commonApi;
